<script>
  import Pattern from "./Pattern.svelte";

  /**
   * The name of the pattern to be rendered.
   * It should match one of the keys in the PATTERN_NAMES object.
   * @type {keyof typeof import("./Pattern.svelte").PATTERN_NAMES}
   */
  export let name;

  // The path color used by default is the one for darkBlueRadiate.
  export let pathColor = "#0064F0";

  export let patternViewBox = null;

  let containerClass = "";
  export { containerClass as class };

  let width;
</script>

<!-- use pattern as background -->
<div
  class="relative z-[--stack-level-pattern-container] {containerClass}"
  bind:clientWidth={width}
  {...$$restProps}
>
  <!-- content -->
  <div class="relative">
    <slot />
  </div>

  <!-- pattern background -->
  {#if name}
    <div class="absolute bottom-0 left-0 z-[--stack-level-pattern-background]">
      <Pattern {name} {pathColor} {patternViewBox} class="h-auto" opacity="0.3" {width} />
    </div>
  {/if}
</div>
